import { sendGTMEvent } from '@next/third-parties/google';

import { CustomDestination } from './Avo';

export const gtmDestination: CustomDestination = {
  logEvent: (event: string, eventProperties: Record<string, unknown>) => {
    sendGTMEvent(function () {
      // @ts-expect-error we don't really care about this
      // eslint-disable-next-line
      this.reset();
    });
    sendGTMEvent({ event, ...eventProperties });
  },
};
